import app from "../../common/app";
import config from "./../../common/config";
const data = [
  {
    id: 0,
    name: "home",
    transKey: "menuHome",
    titleTransKey: "homeTab",
    isRemove: false,
    isHideMenu: false,
    isMaster: false,
    link: config.enumStaticUrls.home,
    linkMenu: config.enumStaticUrls.home,
    isAuthorize: 0,
    isEndOfTour: 0,
    isActive: (match, location) => {
      if (location.pathname.indexOf(`/${config.enumStaticUrls.home}`) > -1) {
        return true;
      }
    },
    iconClassName: "m11ci-home-outline",
  },
  {
    id: 3,
    name: "myTeam",
    transKey: "menuCreateTeam",
    titleTransKey: "createTeamTab",
    isRemove: false,
    isHideMenu: true,
    isMaster: false,
    link: config.enumStaticUrls.createTeam,
    linkMenu: config.enumStaticUrls.createTeam,
    isActive: (match, location) => {
      if (
        location.pathname.indexOf(`/${config.enumStaticUrls.createTeam}`) > -1
      ) {
        return true;
      }
    },
    isAuthorize: 1,
    isEndOfTour: 2,
  },
  {
    id: 4,
    name: "myTeam",
    transKey: "menuTransferTeam",
    titleTransKey: "transferTeamTab",
    isRemove: false,
    isHideMenu: true,
    isMaster: false,
    link: config.enumStaticUrls.transferTeam,
    linkMenu: config.enumStaticUrls.transferTeam,
    isActive: (match, location) => {
      if (
        location.pathname.indexOf(`/${config.enumStaticUrls.transferTeam}`) > -1
      ) {
        return true;
      }
    },

    isAuthorize: 1,
    isEndOfTour: 2,
  },
  {
    id: 5,
    name: "myContest",
    transKey: "menuContest",
    titleTransKey: "myContestTabTitle",
    isRemove: false,
    isHideMenu: false,
    isMaster: false,
    link: config.enumStaticUrls.contest,
    linkMenu: config.enumStaticUrls.contest,
    isActive: (match, location) => {
      if (location.pathname.indexOf(`/${config.enumStaticUrls.contest}`) > -1) {
        return true;
      }
    },
    isAuthorize: 1,
    isEndOfTour: 1,
    iconClassName: "m11ci-leagues-outline",
  },
  {
    id: 6,
    name: "myTeam",
    transKey: "menuViewTeam",
    titleTransKey: "viewTeamTab",
    isRemove: false,
    isHideMenu: true,
    isMaster: false,
    link: config.enumStaticUrls.viewTeam,
    linkMenu: config.enumStaticUrls.viewTeam,
    isActive: (match, location) => {
      if (
        location.pathname.indexOf(`/${config.enumStaticUrls.viewTeam}`) > -1
      ) {
        return true;
      }
    },
    isAuthorize: 1,
    isEndOfTour: 1,
  },
  {
    id: 7,
    name: "stats",
    transKey: "menuStats",
    titleTransKey: "statsTab",
    isRemove: false,
    isHideMenu: false,
    isMaster: false,
    link: config.enumStaticUrls.stats,
    linkMenu: config.enumStaticUrls.stats,
    isActive: (match, location) => {
      if (location.pathname.indexOf(`/${config.enumStaticUrls.stats}`) > -1) {
        return true;
      }
    },
    isAuthorize: 1,
    isEndOfTour: 1,
    iconClassName: "m11ci-stats",
  },
  {
    id: 8,
    name: "rules",
    transKey: "menuRules",
    titleTransKey: "rulesTab",
    isRemove: false,
    isHideMenu: true,
    isMaster: false,
    link: config.enumStaticUrls.rules,
    linkMenu: config.enumStaticUrls.rules,
    isActive: (match, location) => {
      if (location.pathname.indexOf(`/${config.enumStaticUrls.rules}`) > -1) {
        return true;
      }
    },
    isAuthorize: 1,
    isEndOfTour: 1,
    iconClassName: "m11ci-rules",
  },
  //FIXME: Solve the menuBadges,badgesTab

  {
    id: 11,
    name: "badges",
    transKey: "menuBadges",
    titleTransKey: "badgesTab",
    isRemove: false,
    isHideMenu: false,
    isMaster: false,
    link: config.enumStaticUrls.badges,
    linkMenu: config.enumStaticUrls.badges,
    isActive: (match, location) => {
      if (location.pathname.indexOf(`/${config.enumStaticUrls.badges}`) > -1) {
        return true;
      }
    },
    isAuthorize: 1,
    isEndOfTour: 1,
    iconClassName: "m11ci-badge",
  },
  {
    id: 9,
    name: "more",
    transKey: "menuMore",
    titleTransKey: "moreTab",
    isRemove: false,
    isHideMenu: true,
    isMaster: false,
    link: config.enumStaticUrls.more,
    linkMenu: config.enumStaticUrls.more,
    isActive: (match, location) => {
      if (location.pathname.indexOf(`/${config.enumStaticUrls.more}`) > -1) {
        return true;
      }
    },
    isAuthorize: 1,
    isEndOfTour: 1,
    iconClassName: "m11ci-more",
  },
  {
    id: 10,
    name: "prizes",
    transKey: "menuPrizes",
    titleTransKey: "prizesTab",
    isRemove: false,
    isHideMenu: true,
    isMaster: false,
    link: config.enumStaticUrls.prizes,
    linkMenu: config.enumStaticUrls.prizes,
    isActive: (match, location) => {
      if (location.pathname.indexOf(`/${config.enumStaticUrls.prizes}`) > -1) {
        return true;
      }
    },
    isAuthorize: 0,
    isEndOfTour: 0,
    //iconClassName: 'm11ci-prizes'
  },
  {
    id: 12,
    name: "profile",
    transKey: "menuForm",
    titleTransKey: "formTab",
    isRemove: false,
    isHideMenu: true,
    isMaster: false,
    link: config.enumStaticUrls.form,
    linkMenu: config.enumStaticUrls.form,
    isActive: (match, location) => {
      if (location.pathname.indexOf(`/${config.enumStaticUrls.form}`) > -1) {
        return true;
      }
    },
    isAuthorize: 1,
    isEndOfTour: 1,
  },
  {
    id: 13,
    name: "userTransferHistory",
    transKey: "userTransferHistory",
    titleTransKey: "userTransferHistoryTab",
    isRemove: false,
    isHideMenu: true,
    isMaster: false,
    link: config.enumStaticUrls.transfersHistory,
    linkMenu: config.enumStaticUrls.transfersHistory,
    isActive: (match, location) => {
      if (
        location.pathname.indexOf(
          `/${config.enumStaticUrls.transfersHistory}`
        ) > -1
      ) {
        return true;
      }
    },
    isAuthorize: 1,
    isEndOfTour: 0,
  },
  {
    id: 14,
    name: "userBoostersHistory",
    transKey: "userBoostersHistory",
    titleTransKey: "userBoostersHistoryTab",
    isRemove: false,
    isHideMenu: true,
    isMaster: false,
    link: config.enumStaticUrls.boostersHistory,
    linkMenu: config.enumStaticUrls.boostersHistory,
    isActive: (match, location) => {
      if (
        location.pathname.indexOf(`/${config.enumStaticUrls.boostersHistory}`) >
        -1
      ) {
        return true;
      }
    },
    isAuthorize: 1,
    isEndOfTour: 0,
  },
  {
    id: 15,
    name: "userPointsHistory",
    transKey: "userPointsHistory",
    titleTransKey: "userPointsHistoryTab",
    isRemove: false,
    isHideMenu: true,
    isMaster: false,
    link: config.enumStaticUrls.pointsHistory,
    linkMenu: config.enumStaticUrls.pointsHistory,
    isActive: (match, location) => {
      if (
        location.pathname.indexOf(`/${config.enumStaticUrls.pointsHistory}`) >
        -1
      ) {
        return true;
      }
    },
    isAuthorize: 1,
    isEndOfTour: 0,
  },
  {
    id: 16,
    name: "My11Circle",
    transKey: "My11Circle",
    titleTransKey: "My11Circle",
    isRemove: false,
    isHideMenu: !app.isWebView(),
    isMaster: false,
    link: config.enumStaticUrls.stats,
    linkMenu: config.enumStaticUrls.stats,
    isActive: (match, location) => {
      return location.pathname.includes(`/apptype`);
    },
    isAuthorize: 1,
    isEndOfTour: 1,
    iconClassName: "m11ci-my11c",
  },
];
export default data;
